import { defineStore } from 'pinia'

import type { AssignmentTemplatesStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useAssignmentTemplatesStore = defineStore('assignment-templates', {
  state: (): AssignmentTemplatesStore => ({
    loading: false,
    templatesPaginatedData: null,
    filterSearch: null,
    filterType: null,
    filterDisciplineCode: null,
    filterGrade: null,
    filterModuleId: null,
    currentPage: 1,
    perPage: 25,
    isModalCreate: false,
    templateToDelete: null,
    templateToDuplicate: null,
  }),
  actions,
  getters,
})
